import { InkyBannerSettingsState } from '@core/inky-banner-settings/store/states/inky-banner-settings.state';

export const inkyBannerSettingsState = [InkyBannerSettingsState];
